/**
 * Hands off the first-paint loader that index.html bakes into the document.
 *
 * The loader is shown before any JavaScript runs. Once the app shell is mounted,
 * the class fades it out and the node is removed after the CSS transition, so the
 * page never flashes blank. `main.tsx` calls this after two animation frames, so
 * the shell has painted before the loader leaves.
 */

const LOADER_FADE_MS = 300;

export function dismissAppLoader(doc: Document = document): void {
  const loader = doc.querySelector("#app-loader");
  if (!loader) {
    return;
  }
  loader.classList.add("app-loader--hidden");
  setTimeout(() => {
    loader.remove();
  }, LOADER_FADE_MS);
}
